import { Drawer, Grid, Hidden, IconButton, makeStyles, Paper, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import Banner from './banner';
import ContactUs from './contactUs';
import LeftMenu from './leftMenu';
import Feeds from './feeds';
import MenuIcon from "@material-ui/icons/Menu";

const useStyle = makeStyles(theme => ({
    logo: {
        fontSize: 36,
        paddingTop: '1rem',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
        color: theme.palette.primary.main
    },
    drawer: {
        [theme.breakpoints.up('md')]: {
            width: 240,
            flexShrink: 0,

        },
        fontSize: '1rem',
        display: 'flex'
    },
    menuButton: {
        paddingTop: '1rem',
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        marginRight: theme.spacing(2),
        marginLeft: theme.spacing(2),
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    drawerPaper: {
        width: 240,
        backgroundColor: theme.palette.background.default,
        borderRight: '0px solid lightgray',
        color: theme.palette.primary.main,
        minHeight: 200,
        paddingRight: theme.spacing(1)
    },
    content: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            marginLeft: 240
        }
    }
}))

export default function Structure(props) {

    const classes = useStyle();
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen)
    };

    return (
        <div className='d-flex flex-column w-100'>
            <div className='d-flex'>
                <Grid item sm={12} xs={12} className='d-flex d-row'>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        className={classes.menuButton}
                    >
                        <MenuIcon />
                    </IconButton>
                    <div>
                        <Typography className={`${classes.logo}`}>如意花園</Typography>
                    </div>
                </Grid>
            </div>
            <nav className={classes.drawer}>
                <Hidden mdUp implementation="css">
                    <Drawer
                        // container={container}
                        variant="temporary"
                        open={mobileOpen}
                        onClose={handleDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        ModalProps={{
                            keepMounted: true // Better open performance on mobile.
                        }}
                    >
                        <LeftMenu />
                    </Drawer>
                </Hidden>
                <Hidden smDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper
                        }}
                        variant="permanent"
                        open
                    >
                        <LeftMenu />
                    </Drawer>
                </Hidden>
            </nav>
            <Grid container className={classes.content}>
                <Grid item md={9} xs={12} container>
                    <Banner />
                    <Feeds />
                </Grid>
                <Grid item md={3} xs={12}>
                    <ContactUs />
                </Grid>
            </Grid>
        </div>
    )
}